import { useMutation } from 'react-query'

import { type ProfessionalDataDomain } from '../../../../types/domain/professional-data-domain'
import { type ProfessionalDataPersistence } from '../../../../types/persistence/professional-data-persistence'
import { api } from '../../../api'

const useExpertProfessionalData = async (
  id: number,
  data: ProfessionalDataPersistence
): Promise<any> => {
  const smallGroup = data.smallGroup || null
  const blind = data.blind ? data.blind === 'yes' : null
  const proactive = data.proactive || null

  const { bio, observations } = data
  const actions = []

  if (bio || observations) {
    const personalDataUpdate = await api.put(`/experts/${id}`, {
      bio,
      observations,
    })
    actions.push(personalDataUpdate)
  }

  const response = await api.put<ProfessionalDataDomain>(
    `/experts/${id}/professional-data`,
    { ...data, smallGroup, blind, proactive }
  )
  actions.push(response)

  return await Promise.all(actions)
}

export const useExpertProfessionalDataMutation = () => {
  return useMutation({
    mutationFn({
      id,
      data,
    }: {
      id: number
      data: ProfessionalDataPersistence
    }) {
      return useExpertProfessionalData(id, data)
    },
  })
}
